import { useQuery } from '@tanstack/react-query'

import { api } from '../../../services/api'
import { QueryParams } from '../../../types/interfaces'
import { queriesKeys } from '../queriesKeys'

export const useGetEarningRides = (earningId: number, filters?: QueryParams) =>
  useQuery({
    enabled: !!earningId,
    queryFn: () => api.earnings.getEarningRides(earningId, filters),
    queryKey: queriesKeys.earnings.getEarningRides(earningId, filters),
  })
